import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { commonRoutes } from "./routes.data";
import { useUser } from "../contexts/AuthContext";
import InternalError from "../pages/InternalError";
import PageNotFound from "../pages/PageNotFound";

const AppRoutes: React.FC = () => {
	const { user } = useUser();
	return (
		<Routes>
			{commonRoutes.map((route: any) => {
				if (route.doNotShowIfLoggedIn && user) {
					return;
				} else {
					return (
						<Route
							key={route.key}
							path={`/*`}
							element={
								route.protected ? (
									<ProtectedRoute>
										<route.element />
									</ProtectedRoute>
								) : (
									<route.element />
								)
							}
						/>
					);
				}
			})}
			<Route path="/internal-error" element={<InternalError />} />
			<Route path="/error/404" element={<PageNotFound />} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
};

export default AppRoutes;
